import {type UISidebarController} from '../../../ui_html/sidebar/UISidebarController.ts'
import {UIWProfileController} from '../../../profile/UIWProfileController.ts'
import {ClientUserState} from '../../../../../shared/scripts/ClientUserState.ts'

export class UIDProfileSceneController {
    private readonly sidebarController: UISidebarController
    profileController: UIWProfileController
    private readonly profileSceneContainerDiv: HTMLDivElement

    constructor(sidebarController: UISidebarController) {
        this.sidebarController = sidebarController
        this.profileController = new UIWProfileController()
        this.profileSceneContainerDiv = document.getElementById('scene_discord_profile_container') as HTMLDivElement
    }

    hide() {
        this.profileSceneContainerDiv.classList.add('hidden')
    }

    show() {
        this.profileSceneContainerDiv.classList.remove('hidden')
        this.sidebarController.activateProfile()
    }

    async updatePageContent(username: string) {
        const profileController = this.profileController

        profileController.username = username
        profileController.profileLinkController.resetApiCalls()
        profileController.profileLinkController.showSection(0)
        await profileController.getStickyPlayerInfo()
        profileController.friendsController.setUsername(username)

        const userIsMe = ClientUserState.userState?.username === username
        profileController.friendsController.profileIsCurrentUser = userIsMe
        await profileController.friendsController.createDropdown()

        if(userIsMe) {
            profileController.settingsController.showSettingsTab()
            profileController.friendsController.showFriendsTab()
        } else {
            profileController.friendsController.hideFriendsTab()
            profileController.settingsController.hideSettingsTab()
        }

        await profileController.makeApiCall()
    }
}
